import axios from "axios";
// import config from "../../../../../../config";
import config from "../../../../config";

const API_TOKEN = config.MAP_MATCHING_API_TOKEN;
const API_URL = config.MAP_MATCHING_API_URL;

export const fetchFormFields = async () => {
  try {
    const response = await axios.get(`${API_URL}/eventsFormLists`, {
      headers: {
        "X-API-Key": API_TOKEN,
        "Content-Type": "application/json",
      },
    });

    return { data: response.data, error: null };
  } catch (error) {
    console.error("Error fetching form fields:", error);
    return { data: null, error: error.message || "Unknown error" };
  }
};
